import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class PopupMessage extends Vue {
  get message() {
    return this.$store.state.popUpMessage;
  }

  get windowWidth() {
    return window.innerWidth;
  }

  get reducewidthBy() {
    if (this.windowWidth < 500) return 0.8;
    return 0.5;
  }

  closeModal() {
    this.$modal.hide("pop-message");
  }

  opened() {
    window.addEventListener("resize", this.changeWidth);
  }

  beforeClosed() {
    this.$store.commit("setPopUpMsg", "");
    window.removeEventListener("resize", this.changeWidth);
  }

  changeWidth() {
    const windowWidth = window.innerWidth;
    let reducewidthBy = 0.8;
    if (windowWidth > 500) {
      reducewidthBy = 0.5;
    }

    if (this.$refs.modal) {
      (this.$refs.modal as any).modal.width = windowWidth * reducewidthBy;
    }
  }
}
